import React, { useState } from 'react';
import './cta.css';

const FinalCTA = () => {

  const [showForm, setShowForm] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData(e.target);

    await fetch("https://formsubmit.co/ajax/info@wecanserve.com", {
      method: "POST",
      body: data
    });

    setShowForm(false);
    alert("Thanks! We'll get back to you.");
  };

  return (
    <>

      <section className="final-cta-container">

        <div className="final-cta-banner">

          <div className="final-cta-text">
            <h2>Ready to grow your business?</h2>
            <p>Let's build something amazing together.</p>
          </div>

          <div className="final-cta-actions">

            <button
              className="btn-yellow-cta"
              onClick={() => setShowForm(true)}
            >
              Get A Free Consultation
            </button>

            <div className="paper-plane-decoration">
              <img src="/arrow.png" alt="decoration" />
            </div>

          </div>

        </div>

      </section>

      {/* MODAL */}

      {showForm && (

        <div
          className="modal-overlay"
          onClick={() => setShowForm(false)}
        >

          <div
            className="modal-box"
            onClick={(e) => e.stopPropagation()}
          >

            <div className="modal-header">

              <h3>Start a Conversation</h3>

              <span
                className="close-btn"
                onClick={() => setShowForm(false)}
              >
                ✕
              </span>

            </div>

            <form
              onSubmit={handleSubmit}
              className="modal-form"
            >

              <input
                type="hidden"
                name="_captcha"
                value="false"
              />

              <input
                type="text"
                name="name"
                placeholder="Full Name"
                required
              />

              <input
                type="tel"
                name="phone"
                placeholder="Mobile Number (Optional)"
              />

              <input
                type="email"
                name="email"
                placeholder="Email Address"
                required
              />

              <select name="service" required>

                <option value="">
                  Interested Service
                </option>

                <option value="Website Development">
                  Website Development
                </option>

                <option value="Social Media Marketing">
                  Social Media Marketing
                </option>

                <option value="Performance Marketing">
                  Performance Marketing
                </option>

                <option value="SEO Services">
                  SEO Services
                </option>

                <option value="Branding & Positioning">
                  Branding & Positioning
                </option>

                <option value="Content Creation">
                  Content Creation
                </option>

                <option value="PR & Media Coverage">
                  PR & Media Coverage
                </option>

                <option value="AI Automation Solutions">
                  AI Automation Solutions
                </option>

                <option value="Other">
                  Other
                </option>

              </select>

              <textarea
                name="message"
                placeholder="Tell us about your requirement..."
                required
              />

              <button
                type="submit"
                className="btn-send"
              >
                Submit
              </button>

            </form>

          </div>

        </div>

      )}

    </>
  );
};

export default FinalCTA;